// extracted by mini-css-extract-plugin
module.exports = {"csr_pc_C":"C_csr_pc_C__asqjL"};